import { LocalizedValueModel } from '../localized-value.model';
import { DataEntryPresenterModel } from './data-entry-presenter.model';

export class DataEntryTreePresenterModel extends DataEntryPresenterModel {
  hasChildren: boolean;
  childrenCount: number;
  relations: [
    {
      relationName: LocalizedValueModel;
      relationId?: string;
      relationCount: number;
    },
  ];
}
